import { CssBaseline, ThemeProvider } from "@mui/material";
import { PropsWithChildren } from "react";

import { encampLightTheme } from "../theme";

/**
 * Theme provider for the unauthenticated shell — login, the loading spinner,
 * password reset, the auth callback, and error pages.
 *
 * Locked to light: dark mode is an authenticated-app feature reachable only via
 * the in-app toggle, so public pages are always light. The `CssBaseline` gives
 * them an explicit light `body` background instead of letting a persisted/OS
 * dark mode bleed through behind a light container.
 *
 * The authenticated app nests its own `EncampThemeProvider` (see `App`), which
 * overrides this and owns the light/dark toggle.
 */
export function PublicThemeProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={encampLightTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
